/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Chip_Supplier_NetworkInputs */

const tr_landing_community_chip_supplier_network = /** @type {(inputs: Landing_Community_Chip_Supplier_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tedarikçi ağı`)
};

const en_landing_community_chip_supplier_network = /** @type {(inputs: Landing_Community_Chip_Supplier_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supplier network`)
};

const de_landing_community_chip_supplier_network = /** @type {(inputs: Landing_Community_Chip_Supplier_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferantennetzwerk`)
};

const ru_landing_community_chip_supplier_network = /** @type {(inputs: Landing_Community_Chip_Supplier_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сеть поставщиков`)
};

/**
* | output |
* | --- |
* | "Supplier network" |
*
* @param {Landing_Community_Chip_Supplier_NetworkInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_chip_supplier_network = /** @type {((inputs?: Landing_Community_Chip_Supplier_NetworkInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Chip_Supplier_NetworkInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_chip_supplier_network(inputs)
	if (locale === "de") return de_landing_community_chip_supplier_network(inputs)
	if (locale === "ru") return ru_landing_community_chip_supplier_network(inputs)
	return tr_landing_community_chip_supplier_network(inputs)
});